module.exports = __webpack_public_path__ + "static/media/arquivo-icon.47cf88b1.png";